import React, { useState, useEffect } from 'react';

const PriceSlider = ({ min, max, value, onChange }) => {
  const [precio, setPrecio] = useState(value);

  useEffect(() => {
    setPrecio(value);
  }, [value]);

  const handleChange = (e) => {
    const nuevoValor = Number(e.target.value);
    setPrecio(nuevoValor);
    onChange(nuevoValor);
  };

  return (
    <div className="priceInput">
      <div className="label_total flex">
        <label htmlFor="price">Precio Max.</label>
        <h3 className="total">${precio.toLocaleString('es-MX')}</h3>
      </div>
      <div className="input flex">
        <input
          type="range"
          min={min}
          max={max}
          value={precio}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default PriceSlider;